import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
	providedIn: "root",
})
export class TranslateServiceAux {
	constructor(private service: TranslateService) {}

	public getTranslationValue(key: string): string {
		let translated: string = "";
		this.service.get(key).subscribe((text) => (translated = text));
		return translated;
	}
}
